import {NgModule, Optional, SkipSelf} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerModule } from "ngx-spinner";

import { MaterialModule } from "./material.module";
import {RightSidebarService} from "./services/rightsidebar.service";
import {AuthGuard} from "./guards/auth.guard";
import {AuthService} from "./services/auth.service";
import {DynamicScriptLoaderService} from "./services/dynamic-script-loader.service";
import {throwIfAlreadyLoaded} from "./guards/module-import.guard";
import {ComponentsModule} from "./components/components.module";
import {NoTranslateDirective} from "./directives/no-translate.directive";

@NgModule({
  declarations: [
    NoTranslateDirective
  ],
  providers: [
    RightSidebarService,
    AuthGuard,
    AuthService,
    DynamicScriptLoaderService,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    ComponentsModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    NgxSpinnerModule,
    MaterialModule,
    ComponentsModule,
    NoTranslateDirective
  ],
})
export class SharedModule {
  constructor(@Optional() @SkipSelf() parentModule: SharedModule) {
    throwIfAlreadyLoaded(parentModule, 'SharedModule');
  }
}
